import {
  LeadLogs as LEADS,
  DealLogs as DEALS,
  TaskLogs as TASKS,
  EventLogs as EVENTS,
  BookingLogs as BOOKINGS,
  DataRecordLogs as DATA_RECORDS,
  ChannelLogs as CHANNELS,
  SupportLogs as SUPPORT,
  AutomationLogs as AUTOMATIONS,
} from './notifLogs';

const NotificationLog = {
  LEADS: { ...LEADS },
  DEALS: { ...DEALS },
  TASKS: { ...TASKS },
  EVENTS: { ...EVENTS },
  BOOKINGS: { ...BOOKINGS },
  DATA: { ...DATA_RECORDS },
  CHANNELS: { ...CHANNELS },
  SUPPORT: { ...SUPPORT },
  AUTOMATIONS: { ...AUTOMATIONS },
} as Record<string, Record<string, any>>;

export default NotificationLog;
